export const DEFAULT_PARAMS = {
  page: 1,
  per_page: 10
};
